import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SectionLabel } from "@/components/Section";

const STEPS = [
  "Inventory Planning",
  "Regional Warehousing",
  "Dark Store Replenishment",
  "Order Processing",
  "Dispatch Coordination",
  "Last-Mile Support",
  "Customer Delivery",
];

export default function SupplyChainFlow() {
  return (
    <section
      data-testid="section-supply-chain"
      id="supply-chain"
      className="relative overflow-hidden bg-[#1F1F1F] text-white px-5 py-20 lg:py-28"
    >
      <div
        className="absolute inset-0 opacity-50"
        style={{
          background:
            "radial-gradient(circle at 90% 10%, rgba(153,204,0,0.22), transparent 32%), radial-gradient(circle at 5% 85%, rgba(153,204,0,0.10), transparent 38%)",
        }}
      />
      <div className="absolute inset-0 oh-grid-dark opacity-40" />

      <div className="relative mx-auto max-w-7xl">
        <div className="mb-12 grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
          <div>
            <SectionLabel>Supply Chain & Fulfilment</SectionLabel>
            <motion.h2
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5 }}
              className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-display font-black leading-[1.05] tracking-tight"
            >
              End-to-end operating network for <span className="text-[#99CC00]">fast commerce.</span>
            </motion.h2>
          </div>
          <p className="text-lg lg:text-xl leading-relaxed text-white/70">
            From inventory placement to last-mile movement, OneHill helps brands and platforms build faster operating networks across Tier 1, Tier 2 and Tier 3 India.
          </p>
        </div>

        <div className="rounded-[2rem] border border-white/10 bg-white/[0.04] p-6 lg:p-8 backdrop-blur-xl">
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-7">
            {STEPS.map((step, i) => (
              <motion.div
                key={step}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                data-testid={`flow-step-${i}`}
                className="relative rounded-3xl bg-black/30 p-5 text-center border border-white/5"
              >
                <div
                  className="mx-auto mb-4 flex h-11 w-11 items-center justify-center rounded-full text-lg font-display font-black text-[#1F1F1F]"
                  style={{ background: "#99CC00" }}
                >
                  {i + 1}
                </div>
                <div className="text-sm font-black leading-5 text-white">{step}</div>
                {i < STEPS.length - 1 ? (
                  <ArrowRight className="absolute -right-4 top-1/2 hidden lg:block h-5 w-5 -translate-y-1/2 text-[#99CC00]" />
                ) : null}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
